// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loan-payment-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #333;
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.loan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.title-section {
  display: flex;
  align-items: center;
}

.title-icon {
  color: #333;
  font-size: 1.2rem;
  margin-right: 10px;
}

.loan-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.loan-id {
  color: #666;
  font-weight: normal;
  margin-left: 8px;
}

.loan-actions {
  display: flex;
  height: 40px;
  max-height: 32px
}

.action-button {
  padding: 10px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  font-size: 14px;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.action-button i {
  margin-right: 8px;
}

.download-button {
  background-color: #f8f9fa;
  color: #333;
  border: 1px solid #ddd;
}

.download-button:hover {
  background-color: #e9ecef;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.top-up-button {
  background-color: #F79222;
  color: white;
}

.top-up-text {
  color: white;
}

.top-up-button:hover {
  background-color: #e58420;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.loan-info-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
  border: 1px solid #e9ecef;
  margin-bottom: 24px;
}

.card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  border-bottom: 2px solid #F9394C;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px 5px 15px;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  width: auto;
  max-width: -moz-fit-content;
  max-width: fit-content;
}

.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.status-badge.status-active {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #4caf50;
}

.status-badge.status-pending {
  background-color: #fff8e1;
  border: 1px solid #F79222;
  color: #F79222;
}

.status-badge.status-completed {
  background-color: #e3f2fd;
  color: #1565c0;
  border: 1px solid #2196f3;
}

.status-badge.status-defaulted {
  background-color: #ffebee;
  color: #F9394C;
  border: 1px solid #F9394C;
}

.status-badge.status-cleared {
  background-color: #e0f2f1;
  color: #00695c;
  border: 1px solid #009688;
}

.status-badge.status-disbursed {
  background-color: #fff8e1;
  color: #F79222;
  border: 1px solid #F79222;
}

.status-badge.status-default {
  background-color: #f5f5f5;
  color: #616161;
  border: 1px solid #9e9e9e;
}

.status-icon {
  margin-right: 8px;
  font-size: 14px;
}

.status-text {
  letter-spacing: 0.5px;
}

.section-header {
  margin-bottom: 20px;
}

.section-header h4 {
  color: #F9394C;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.section-header hr {
  margin-top: 0;
  border-color: #e9ecef;
}

.loan-summary-section, .financial-details-section, .repayment-progress-section, .guarantor-section {
  padding: 24px;
  border-bottom: 1px solid #e9ecef;
}

.summary-grid, .financial-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
}

.summary-item, .financial-item {
  margin-bottom: 8px;
  padding: 16px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
  border: 1px solid #dee2e6;
}

.summary-item:hover, .financial-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.item-label {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}

.item-value {
  font-size: 16px;
  font-weight: 600;
  color: #212529;
}

.duration-details {
  font-size: 13px;
  font-weight: normal;
  color: #6c757d;
  margin-top: 4px;
}

.payment-table-container {
  margin: 16px;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  border: 1px solid #dee2e6;
}

.payment-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.progress-details {
  margin: 16px;
  padding: 16px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  border: 1px solid #dee2e6;
}

.progress-text {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-weight: 500;
}

.progress-status {
  font-weight: 600;
}

.status-paid {
  color: #28a745;
}

.progress-bar-container {
  height: 10px;
  background-color: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 12px;
}

.progress-bar {
  height: 100%;
  background-color: #F79222;
  border-radius: 5px;
  transition: width 0.6s ease;
}

.days-remaining {
  text-align: right;
  font-size: 14px;
  color: #6c757d;
}

.guarantor-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.guarantor-table th {
  background-color: #f8f9fa;
  text-align: left;
  padding: 14px 16px;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
}

.guarantor-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #dee2e6;
  background-color: white;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

.payment-section {
  margin-top: 24px;
}

.payment-component {
  margin-top: 0;
}

.loan-details-container {
  padding: 20px;
  gap: 24px;
  display: flex;
  flex-direction: column;
}

.details-card {
  background: white;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  overflow: hidden;
}

.card-header {
  padding: 16px 24px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  color: #2D3748;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.status-badge {
  background-color: #E6F4EA;
  color: #1E7E34;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.summary-content,
.financial-content {
  padding: 24px;
}

.details-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 24px;
}

.details-row:last-child {
  margin-bottom: 0;
}

.detail-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-group label {
  color: #718096;
  font-size: 13px;
  font-weight: 500;
}

.detail-group .value {
  color: #2D3748;
  font-size: 15px;
  font-weight: 500;
}

.detail-group .value.highlight {
  color: #F79222;
  font-weight: 600;
}

.status-badge i {
  font-size: 14px;
}

.overdue-text {
  color: red;
}

.no-data-message {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/App/components/Loan/admin/ViewLoanPayments.css"],"names":[],"mappings":"AAAA;EACE,gGAAgG;EAChG,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,WAAW;EACX,2BAAsB;EAAtB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV","sourcesContent":[".loan-payment-container {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  color: #333;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.loan-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.title-section {\n  display: flex;\n  align-items: center;\n}\n\n.title-icon {\n  color: #333;\n  font-size: 1.2rem;\n  margin-right: 10px;\n}\n\n.loan-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.loan-id {\n  color: #666;\n  font-weight: normal;\n  margin-left: 8px;\n}\n\n.loan-actions {\n  display: flex;\n  height: 40px;\n  max-height: 32px\n}\n\n.action-button {\n  padding: 10px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n}\n\n.action-button i {\n  margin-right: 8px;\n}\n\n.download-button {\n  background-color: #f8f9fa;\n  color: #333;\n  border: 1px solid #ddd;\n}\n\n.download-button:hover {\n  background-color: #e9ecef;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.top-up-button {\n  background-color: #F79222;\n  color: white;\n}\n\n.top-up-text {\n  color: white;\n}\n\n.top-up-button:hover {\n  background-color: #e58420;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.loan-info-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  overflow: hidden;\n  border: 1px solid #e9ecef;\n  margin-bottom: 24px;\n}\n\n.card-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #F9394C;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 10px 5px 15px;\n  border-radius: 30px;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  width: auto;\n  max-width: fit-content;\n}\n\n.status-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.status-badge.status-active {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  border: 1px solid #4caf50;\n}\n\n.status-badge.status-pending {\n  background-color: #fff8e1;\n  border: 1px solid #F79222;\n  color: #F79222;\n}\n\n.status-badge.status-completed {\n  background-color: #e3f2fd;\n  color: #1565c0;\n  border: 1px solid #2196f3;\n}\n\n.status-badge.status-defaulted {\n  background-color: #ffebee;\n  color: #F9394C;\n  border: 1px solid #F9394C;\n}\n\n.status-badge.status-cleared {\n  background-color: #e0f2f1;\n  color: #00695c;\n  border: 1px solid #009688;\n}\n\n.status-badge.status-disbursed {\n  background-color: #fff8e1;\n  color: #F79222;\n  border: 1px solid #F79222;\n}\n\n.status-badge.status-default {\n  background-color: #f5f5f5;\n  color: #616161;\n  border: 1px solid #9e9e9e;\n}\n\n.status-icon {\n  margin-right: 8px;\n  font-size: 14px;\n}\n\n.status-text {\n  letter-spacing: 0.5px;\n}\n\n.section-header {\n  margin-bottom: 20px;\n}\n\n.section-header h4 {\n  color: #F9394C;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.section-header hr {\n  margin-top: 0;\n  border-color: #e9ecef;\n}\n\n.loan-summary-section, .financial-details-section, .repayment-progress-section, .guarantor-section {\n  padding: 24px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.summary-grid, .financial-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 24px;\n}\n\n.summary-item, .financial-item {\n  margin-bottom: 8px;\n  padding: 16px;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n  transition: all 0.2s ease;\n  border: 1px solid #dee2e6;\n}\n\n.summary-item:hover, .financial-item:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.item-label {\n  color: #6c757d;\n  font-size: 14px;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.item-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.duration-details {\n  font-size: 13px;\n  font-weight: normal;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n.payment-table-container {\n  margin: 16px;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n  border: 1px solid #dee2e6;\n}\n\n.payment-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n}\n\n.progress-details {\n  margin: 16px;\n  padding: 16px;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n  border: 1px solid #dee2e6;\n}\n\n.progress-text {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.progress-status {\n  font-weight: 600;\n}\n\n.status-paid {\n  color: #28a745;\n}\n\n.progress-bar-container {\n  height: 10px;\n  background-color: #e9ecef;\n  border-radius: 5px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.progress-bar {\n  height: 100%;\n  background-color: #F79222;\n  border-radius: 5px;\n  transition: width 0.6s ease;\n}\n\n.days-remaining {\n  text-align: right;\n  font-size: 14px;\n  color: #6c757d;\n}\n\n.guarantor-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n}\n\n.guarantor-table th {\n  background-color: #f8f9fa;\n  text-align: left;\n  padding: 14px 16px;\n  font-weight: 600;\n  color: #495057;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.guarantor-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #dee2e6;\n  background-color: white;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px 0;\n}\n\n.payment-section {\n  margin-top: 24px;\n}\n\n.payment-component {\n  margin-top: 0;\n}\n\n.loan-details-container {\n  padding: 20px;\n  gap: 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n.details-card {\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n  overflow: hidden;\n}\n\n.card-header {\n  padding: 16px 24px;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.card-title {\n  color: #2D3748;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.status-badge {\n  background-color: #E6F4EA;\n  color: #1E7E34;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.summary-content,\n.financial-content {\n  padding: 24px;\n}\n\n.details-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.details-row:last-child {\n  margin-bottom: 0;\n}\n\n.detail-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.detail-group label {\n  color: #718096;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.detail-group .value {\n  color: #2D3748;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.detail-group .value.highlight {\n  color: #F79222;\n  font-weight: 600;\n}\n\n.status-badge i {\n  font-size: 14px;\n}\n\n.overdue-text {\n  color: red;\n}\n\n.no-data-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #6c757d;\n  font-size: 14px;\n  font-weight: 500;\n  gap: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
